import React, { useMemo } from 'react'
import Typography from '@/v2/components/common/Typography'
import Grid from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'
import { hideUnregister } from '@/v2/utils/helpers'

const DefaultMethod = ({ paymentMethods, invoice, variant = 'desktop' }) => {
  const theme = useTheme()
  const isMobile = variant === 'mobile'
  const valueFontSize = isMobile ? '14px' : '15px'
  const labelLineHeight = isMobile ? '18px' : '23px'

  const defaultPaymentCard = useMemo(() => {
    if (paymentMethods && paymentMethods.length > 0) {
      return paymentMethods.find(
        paymentMethod => paymentMethod.id === invoice.paymentMethodId
      )
    }
    return null
  }, [paymentMethods, invoice.paymentMethodId])

  const renderValue = () => {
    if (defaultPaymentCard) {
      return (
        <Typography fontSize={valueFontSize}>
          {`${defaultPaymentCard.type === 'credit_card' ? 'Card' : 'ACH'} (${
            defaultPaymentCard.last4
          })`}
        </Typography>
      )
    }

    if (!defaultPaymentCard && invoice.paymentMethodId) {
      return (
        <Grid
          item
          display="flex"
          alignItems={'flex-start'}
          justifyContent={'flex-start'}
        >
          <Typography
            wordBreak
            textAlign={'left'}
            variant={'body'}
            fontSize={valueFontSize}
          >
            {hideUnregister(invoice) ? 'None' : 'Unregistered'}
          </Typography>
        </Grid>
      )
    }

    if (invoice.sendPaymentLink && !invoice.paymentMethodId) {
      return (
        <Typography wordBreak fontSize={valueFontSize}>
          None
          <Typography wordBreak fontSize="12px">
            (Payment link sent)
          </Typography>
        </Typography>
      )
    }

    return (
      <Typography wordBreak fontSize={valueFontSize}>
        None
      </Typography>
    )
  }

  const content = (
    <>
      <Typography
        fontSize="10px"
        lineHeight={labelLineHeight}
        color={theme.palette.gray.dark}
      >
        DEFAULT METHOD
      </Typography>
      {renderValue()}
    </>
  )

  return isMobile ? (
    <div>{content}</div>
  ) : (
    <Grid item xs={1}>
      {content}
    </Grid>
  )
}

export default DefaultMethod
